import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { PaymentPlanId, type Product } from 'helpers/getPlans';
import { useLocaleNavigate } from 'hooks/useLocaleNavigate';

import { sendAnalyticEvent } from 'data/actions/analytics';
import { toggleModal } from 'data/actions/modals';
import { buyUpsaleProduct, getPlans, upsaleCurrentPlan } from 'data/actions/subscriptions';

import { PAGE_LINKS } from 'ts/constants/page-links';

type GetPlansResponse = {
  payload: Product[];
};

type ExtendedProduct = Product & {
  credits: number;
};

export const useOneTimeUpsaleProducts = () => {
  const [upsalePlans, setUpsalePlans] = useState<ExtendedProduct[]>([]);
  const [selectedPlan, setSelectedPlan] = useState<ExtendedProduct | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [isBuying, setIsBuying] = useState(false);
  const navigate = useLocaleNavigate();
  const dispatch = useDispatch();

  const currentPlace = () => {
    const currentPath = window.location.pathname;
    if (currentPath.includes('account-settings')) {
      return 'dashboard';
    }
    return 'thank_you_page';
  };

  useEffect(() => {
    dispatch(getPlans({ userCountry: localStorage.getItem('userCountry') || '' })).then((res: GetPlansResponse) => {
      const filteredPlans = res.payload.filter(
        (item) =>
          item.name === PaymentPlanId.TEN_UPSALE ||
          item.name === PaymentPlanId.THIRTY_UPSALE ||
          item.name === PaymentPlanId.FIFTY_UPSALE
      );

      const extendedPlans = filteredPlans
        .map((plan) => {
          let credits = 0;
          switch (plan.name) {
            case PaymentPlanId.TEN_UPSALE:
              credits = 10;
              break;
            case PaymentPlanId.THIRTY_UPSALE:
              credits = 30;
              break;
            case PaymentPlanId.FIFTY_UPSALE:
              credits = 50;
              break;
          }
          return { ...plan, credits };
        })
        .sort((a, b) => a.credits - b.credits);

      setUpsalePlans(extendedPlans);
      setSelectedPlan(extendedPlans[0]);
      setIsLoading(false);
    });
  }, [dispatch]);

  const handleBuyUpsaleProduct = () => {
    dispatch(
      sendAnalyticEvent({
        event: 'upsale_modal_accept_tap',
        data: {
          screen_config_name: 'transactional_credits_access',
          planName: selectedPlan?.name,
          placement: currentPlace()
        }
      })
    );
    setIsBuying(true);
    dispatch(upsaleCurrentPlan(selectedPlan));
    dispatch(
      buyUpsaleProduct(
        selectedPlan?.id || '',
        selectedPlan?.price.currency || '',
        () => {
          console.log('success');
        },
        () => {
          dispatch(toggleModal({ visible: false }));
          navigate(PAGE_LINKS.PAYMENT);
        }
      )
    );
  };

  return { upsalePlans, isLoading, selectedPlan, setSelectedPlan, handleBuyUpsaleProduct, isBuying, currentPlace };
};
